import React, { useState } from "react";
import { toast } from "react-toastify";
import { ADMIN_BASE_URL, API_BASE_URL } from '../../src/pages/config';
export default function MemberIdCell({ value, data,onRefresh, onFreezeRequest  }) {
   
    const [open, setOpen] = useState(false);
   
    const handleFreezeToggle = async (userId, action,username,email) => {
        console.log("isername",username)
        console.log("iemail",email)
        const token = localStorage.getItem("token");
        const isFreezed = action == 1 ? 1 : 0;

        const apiCall = async () => {
        try {
            const response = await fetch(
            `${ADMIN_BASE_URL}/adminapi/users/${userId}/freeze?is_freezed=${isFreezed}`,
            {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ is_freezed: isFreezed }),
            }
            );
            const result = await response.json();
            if (!response.ok) throw new Error(result.message);
            onRefresh();
            toast.success(`User ${isFreezed ? "revoked" : "resumed"} successfully.`);
        } catch (err) {
            toast.error(err.message || "Failed to update user status.");
        }
        };

        // Instead of calling API immediately -> ask parent to open modal
        onFreezeRequest(userId, action,username,email, apiCall);
    };

   
    return (
        <>
        <div 
            style={{ display: "block", cursor: "pointer" }} 
            onMouseEnter={() => setOpen(true)} 
            onMouseLeave={() => setOpen(false)}
        >
        <span style={{ fontWeight: 600, }}>{value}</span>
            {/* Native Select Dropdown */}
            {open && (
                <select
                    value={data.is_freezed} 
                    style={{
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "4px 8px",
                        cursor: "pointer",
                        marginLeft:"6px"
                    }}
                    onChange={(e) => handleFreezeToggle(data.id, e.target.value,data.user_name,data.email)}
                >
                    <option value="" disabled>
                    Actions
                    </option>
                    <option value="1">REVOKE</option>
                    <option value="0">RESUME</option>
                </select>
            )}
            {/* Password Modal */}
        </div>
        </>
    );
}
